import React, { useState } from 'react';
import { Col, Container, Image, Row } from "react-bootstrap";
import { Navigate } from 'react-router-dom';
import Paths from './Paths';
import { CreateUserForm } from '../components/UserCreationForm/CreateUserForm';

function CreateUserPage(): JSX.Element {
    const [creationSuccessful, setCreationSuccessful] = useState<boolean>(false);

    const onSuccessfulCreation = (): void => {
        setCreationSuccessful(true);
    };

    return creationSuccessful ? <Navigate to={Paths.login} replace={true} /> : (
        <Container fluid data-bs-theme="dark" data-theme="dark" className="text-light" id="body">
            <Row className="justify-content-center">
                <Col className="d-flex justify-content-center">
                    <Image src={process.env.PUBLIC_URL + '/sc_logo.jpg'} style={{ height: 169 }} />
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col className="d-flex justify-content-center">
                    <CreateUserForm onSuccess={onSuccessfulCreation} />
                </Col>
            </Row>
        </Container>
    );
}

export { CreateUserPage };
